import { PeriodType } from './enums/PeriodType'
import DurationStringJson from './interfaces/DurationStringJson'

export default class DurationString {
  duration: string
  period_type: PeriodType

  constructor(duration: string, period_type: PeriodType) {
    this.duration = duration
    this.period_type = period_type
  }

  static fromJson(data: DurationStringJson) {
    return new this(data.duration, data.period_type)
  }
}
